import { Operation } from '../../core/services/app-config.service';

export class LoaderStatus {
  enabled: boolean;
  lockScreen: boolean;
  operation: Operation;
  requireSubscription: boolean;
}
